export default "/images/vendor/flag-icon-css/flags/4x3/ss.svg?65f6eee5fd80394c659f0f8b5a773e89";